module.exports = __webpack_public_path__ + "static/media/and_now.28e1d22c.png";